import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { analyticsHandlers, analyticsInitialState, analyticsReducer } from '../reducers/AnalyticsReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { useRenders } from './useHelpers/useRenders';
// import ReactGA from 'react-ga';

export const AnalyticsContext = createContext();

/**
 * Simple wrapper to handle analytics
 */
const AnalyticsProvider = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { googleAnalytics } = aps_global ?? {}
  const { allowGoogleAnalytics } = googleAnalytics ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  useRenders('AnalyticsProvider', true)
  // const analytics = getAnalytics(mainApp);

  const init_state = { allowGoogleAnalytics, isSuperAdmin }
  const [analytics_state, analytics_dispatch] = useReducer(analyticsReducer, analyticsInitialState(init_state))

  const analytics_handlers = useMemo(
    () => analyticsHandlers(analytics_dispatch),
    [analytics_dispatch]
  );

  // useEffect(() => {
  //   analytics_handlers.handleInit_analytics(analytics, allowGoogleAnalytics, isSuperAdmin)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, [analytics, allowGoogleAnalytics, isSuperAdmin]);

  return <AnalyticsContext.Provider value={{ analytics_state, analytics_handlers }}>
    {props.children}
  </AnalyticsContext.Provider>
};

export default AnalyticsProvider